<script setup lang="ts">
withDefaults(defineProps<{
  components: any[]
  tag?: string
}>(), {
  tag: 'div'
})

const getComponent = (name: string) => {
  return "Cms" + name.charAt(0).toUpperCase() + name.slice(1);
}
</script>

<template>
  <component :is="tag">
    <component :is="getComponent(component.name)" v-for="component in components" :key="component.id"
      v-bind="component.props" />
  </component>
</template>
